/**
 * How an opportunity comes (D-226), as Core's Opportunity::channelSql reads it: bought by a
 * partner for an end customer (the buyer is the partner), referred by a partner, or direct.
 * For lists filtered on the device's replica.
 */
const uuidOf = (row, name) => row?.[name]?.uuid ?? row?.[`${name}_uuid`] ?? null

export function channelOf(row) {
  const buyer = uuidOf(row, 'account')
  const end = uuidOf(row, 'end_customer')
  if (end && end !== buyer) return 'partner'
  return uuidOf(row, 'referred_by') ? 'referred' : 'direct'
}

/** The partner of an opportunity: the buyer buying for an end customer, else the referrer. */
export function partnerOf(row) {
  return channelOf(row) === 'partner' ? uuidOf(row, 'account') : uuidOf(row, 'referred_by')
}
